import { Alert, Card, Table, Form, Row, Col, Modal, Button, Dropdown, InputGroup } from "react-bootstrap";
import Loading from "../../Loading";
import BuilderDocumentRow from "./BuilderDocumentRow";
import { useEffect, useState } from "react";
import { getBuilderDocs } from "./BuilderDocFuncs";
import { lddGlobalSessionInfo } from "../../navigationTypes";
import { useAppSelector } from "../../../redux/hooks";
import { lddStateObject, setEsignAskfieldsForm } from "../../../redux/reducer";
import { getDataReader } from "../../../livedataFuncs";
import { BuilderDocType, BuilderStateType, EsignAskfieldsItemProps } from "./types";
import BuilderBanner from "../BuilderBanner";
import axios from "axios";
import React from "react";
import ThirdPartyUpload from "./ThirdPartyUpload";
import { useDispatch, useSelector } from "react-redux";
import { setIndicators } from "../../../redux/reducer";
import { RootState } from "../../../redux/store";
import ScheduleEsign from "./Modals/ScheduleEsign";
import getRemoteSigningSchedule from '../../clientportal/pages/Dashboard/ConfigureSigning';
import setScheduleandPortalData  from '../../clientportal/pages/Dashboard/ConfigureSigning';
import JuratDetailModal from './Modals/JuratDetailsModal';
import { ListPlaceholder } from "../../ui/listPlaceholder/listPlaceholder";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const BuilderEsign = () => {
  const livedataRootContainer = useAppSelector(
    (state: lddStateObject) => state.currentNavigation.livedataRootContainer
  );
  const sessionInfo: lddGlobalSessionInfo = useAppSelector(
    (state) => state.SessionInfo
  );
  const [sellerDocs, setSellerDocs] = useState<Array<BuilderDocType>>([]);
  const [builderState, setBuilderState] = useState<BuilderStateType>({
    appId: "",
    appCode: "",
    msgID: "",
  });
  const [purchasers, setPurchasers] = useState<any[]>([]);
  const [checkboxFields, setCheckboxFields] = useState<any[]>([]);
  const [specificFields, setSpecificCheckboxFields] = useState<any[]>([]);
  const [stringSpecificFields, setSpecificStringFields] = useState<any[]>([]);
  const [normalFields, setNormalFields] = useState<any[]>([]);
  const [formValues, setFormValues] = useState<{ [key: string]: string }>({});
  const [purchaserList, setPurchaserList] = useState<string[]>([]);
  const [thirdPartyDocInfo, setThirdPartyDocInfo] = useState<any[]>([]);
  const [scheduledTime, setScheduledTime] = useState<string>('');
  const [firmName, setFirmName] = useState<string>('');
  const [lawyerName, setLawyerName] = useState<string>('');
  const [JuratPackageList, setJuratPackageList] = useState<string[]>([]);
  const [projectName, setProjectName] = useState<string>('');
  const [showRemoteSigningModal, setShowRemoteSigningModal] = useState<boolean>(false);
  const [thirdPartyDocUploadStatus, setThirdPartyDocUploadStatus] = useState<
    boolean[]
  >([]);
  const [clientEmail, setClientEmail] = useState<{ name: string, email: string }[]>([]);
  const dispatch = useDispatch();
  const formData = useSelector((state: RootState) => state.esignAskfieldsForm);
  const [propertyAddress, setPropertyAddress] = useState<string>("");
  const [showModal, setShowModal] = useState(false);
  const [schedule, setSchedule] = useState<any[]>([]);
  const [showJuratModal, setShowJuratModal] = useState<boolean>(false);
  const [isRemoteSigning, setIsRemoteSigning] = useState<boolean>(false);
  const [juratFileName, setJuratFileName] = useState<string>("");
  const [vendorFirmName, setVendorFirmName] = useState<string>("");
  const [commonFiles, setCommonFiles] = useState<string[]>([]);
  const [clientName, setClientName] = useState<string>("");
  const [contractPrice, setContractPrice] = useState<string>("");
  const [deposits, setDeposits] = useState<string>("");
  const [mortgageinfo, setMortgageinfo] = useState<any>({});
  const [initLawyerName, setInitLawyerName] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [globalPreviewDisabled, setGlobalPreviewDisabled] = useState(false);
  const [claimantFields, setClaimantFields] = useState<any[]>([]);
  useEffect(() => {
    if (livedataRootContainer?.dataRoot) {
      const DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
      if (DataReaderObj) {
        
        setClientName(DataReaderObj.getClientName());
        setContractPrice(DataReaderObj.getContractPrice());
        setDeposits(DataReaderObj.getDepositTotal());
        setMortgageinfo(DataReaderObj.getMortgageInformation());
        setPropertyAddress(DataReaderObj.getPropertyAddress());
        setFirmName(DataReaderObj.getFirmName());
        setProjectName(DataReaderObj.getVIPInfoProjName());
        setVendorFirmName(DataReaderObj.getOtherSideLawyerFirmName());
        if(DataReaderObj.getLawyerName()){
          setInitLawyerName(DataReaderObj.getLawyerName());
        }else{
          let node = livedataRootContainer.dataRoot as any;
          const ret = node.runXpath("@BuyerName");
          setInitLawyerName(ret);
        }
      }
    }
  }, [livedataRootContainer.dataRoot]);


  useEffect(() => {
    let id: string, appCode: string, msgID: string;
    let dataResponse: any;
    if (livedataRootContainer?.dataRoot) {
      const DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
      id = DataReaderObj.getAppId();
      appCode = DataReaderObj.getAppCode();
      msgID = DataReaderObj.getVIPInfoMsgID();
      const clientContact = DataReaderObj.getClientEmail(); 
      setClientEmail(clientContact);
      setBuilderState({ appId: id, appCode: appCode, msgID: msgID });
    }
    fetch(
      `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${sessionInfo.firm.id}/${sessionInfo.user.account}/msgxml?MsgID=${msgID}&SessionID=${sessionInfo.sid}`
    )
      .then((response) => response.text())
      .then((text) => {
        dataResponse = text;

        let xmlDom = new ajaxslt.XDocument();
        xmlDom.loadXML(dataResponse);
        let doc = xmlDom.documentElement;
        const purchasers = Array.from(
          doc.getElementsByTagName("Purchaser")
        )
          .map((purchaser) => {
            const name = purchaser.getAttribute("Name");
            return {
              name: name || "Unknown",
            };
          })
          .filter((purchaser) => purchaser.name && purchaser.name !== "Unknown");
        setPurchasers(purchasers);
      })
      .catch((error) => {
        console.error("Error fetching or parsing data:", error);
      });
    const fetchFields = async () => {
      const fields = await getDocumentFileds(msgID);
      const {
        checkboxFields,
        normalFields,
        specificFields,
        stringSpecificFields,
      } = filterFields(fields);

      // Extract claimant information
      const claimants = fields.filter(field => 
        field.name.startsWith("Claimant") && 
        field.name !== "MultipleClaimants" && 
        field.name !== "AllClaimants"
      );

      const parseName = (value: string): { surname: string; givennames: string; lastNameFirst: string } => {
        const trimmed = value.trim();
        let surname = "";
        let givennames = "";
        
        const posComma = trimmed.indexOf(",");
        
        if (posComma !== -1) {
          surname = trimmed.substring(0, posComma).trim();
          givennames = trimmed.substring(posComma + 1).trim();
        } else {
          const posSpace = trimmed.lastIndexOf(" ");
          if (posSpace !== -1) {
            givennames = trimmed.substring(0, posSpace).trim();
            surname = trimmed.substring(posSpace + 1).trim();
          } else {
            givennames = trimmed;
            surname = "";
          }
        }
        
        const lastNameFirst = surname && givennames
          ? `${surname}, ${givennames}`
          : surname || givennames;
        
        return { surname, givennames, lastNameFirst };
      };

      const normalizeNameForComparison = (name: string): string => {
        const parsed = parseName(name);
        return parsed.lastNameFirst.toLowerCase().replace(/\s+/g, ' ').trim();
      };

      const processedClaimants = claimants.map(claimant => {
        if (claimant.name === "ClaimantMain") {
          const nameInfo = parseName(claimant.value);
          return {
            ...claimant,
            value: nameInfo.lastNameFirst
          };
        }
        return claimant;
      });

      const uniqueClaimants = [];
      const seenNormalized = new Set<string>();
      
      const mainClaimant = processedClaimants.find(claimant => claimant.name === "ClaimantMain");
      if (mainClaimant) {
        const normalized = normalizeNameForComparison(mainClaimant.value);
        if (!seenNormalized.has(normalized)) {
          uniqueClaimants.push(mainClaimant);
          seenNormalized.add(normalized);
        }
      }
      
      processedClaimants.forEach(claimant => {
        if (claimant.name !== "ClaimantMain") {
          const normalized = normalizeNameForComparison(claimant.value);
          if (!seenNormalized.has(normalized)) {
            uniqueClaimants.push(claimant);
            seenNormalized.add(normalized);
          }
        }
      });

      setClaimantFields(uniqueClaimants);
      
      const initialFormValues: { [key: string]: string } = {};
      
      if (uniqueClaimants.length > 1) {
        const mainClaimant = uniqueClaimants.find(claimant => claimant.name === "ClaimantMain");
        initialFormValues["rebateClaimantSelection"] = mainClaimant ? mainClaimant.value : "";
      }
      normalFields.forEach((field, idx) => {
        initialFormValues[`formField${idx}`] =
          (field.value?.startsWith(" ") ? field.value.slice(1) : field.value) ||
          "";
      });
      checkboxFields.forEach((field, idx) => {
        if (field.name !== "PurchaserDetailsESigning.HSTEligibility" && field.name !== "PurchaserDetailsESigning.OccupantDetails" && field.name !== "AssigneeDetailsESigning.AssigneeHSTEligibility" && field.name !== "PurchaserDetailsESigning.HSTEligibilitySimple") {
        initialFormValues[`checkboxField${idx}`] =
          Array.isArray(field.value) && field.value[0]?.value === " [true]"
            ? "true"
            : "false";
        }
        if (field.name === "PurchaserDetailsESigning.HSTEligibility") {
          for (let i = 0; i < 2; i++) {
            const tempFieldKey = `${field.name}-${i}`;
            initialFormValues[tempFieldKey] = "false";
          }
          if (Array.isArray(field.value)) {
            const optionIndex = getMatchingOptionIndexForHSTEligibility(field.value[0]?.value);
            initialFormValues[`${field.name}-${optionIndex}`] = "true";
          }
        }

        if (field.name === "PurchaserDetailsESigning.HSTEligibilitySimple") {
          for (let i = 0; i < 2; i++) {
            const tempFieldKey = `${field.name}-${i}`;
            initialFormValues[tempFieldKey] = "false";
          }
          if (Array.isArray(field.value)) {
            const optionIndex = getMatchingOptionIndexForHSTEligibilitySimple(field.value[0]?.value);
            initialFormValues[`${field.name}-${optionIndex}`] = "true";
          }
        }

        if (field.name === "AssigneeDetailsESigning.AssigneeHSTEligibility") {
          for (let i = 0; i < 2; i++) {
            const tempFieldKey = `${field.name}-${i}`;
            initialFormValues[tempFieldKey] = "false";
          }
          if (Array.isArray(field.value)) {
            const optionIndex = getMatchingOptionIndexForAssigneeHSTEligibility(field.value[0]?.value);
            initialFormValues[`${field.name}-${optionIndex}`] = "true";
          }
        }
        if (field.name === "PurchaserDetailsESigning.OccupantDetails") {
          for (let i = 0; i < 4; i++) {
            const tempFieldKey = `${field.name}-${i}`;
            initialFormValues[tempFieldKey] = "false";
          }
          if (Array.isArray(field.value)) {
            const optionIndex = getMatchingOptionIndexForOccupantDetails(field.value[0]?.value);
            initialFormValues[`${field.name}-${optionIndex}`] = "true";
            setOccupantDetailsAdditionalFields(initialFormValues,  field.value, optionIndex, field.name);
          }
          
        }
      const additionalFields = additionalFieldsConfig[field.name];
        if (additionalFields) {
          additionalFields.forEach((label, fieldIdx) => {
            const additionalValue = Array.isArray(field.value)
              ? (field.value
                  .find((v) => v.name === label)
                  ?.value?.startsWith(" ")
                  ? field.value.find((v) => v.name === label)?.value.slice(1)
                  : field.value.find((v) => v.name === label)?.value) || ""
              : "";
            initialFormValues[`additionalField${idx}-${fieldIdx}`] =
              additionalValue;
          });
        }
      });
      let purchasernamelist: string[] = [];
      const fieldsByPurchaser = specificFields.reduce((acc, field) => {
        const purchaserName = field.purchasername || "unknown";
        if (!acc[purchaserName]) {
          acc[purchaserName] = [];
        }
        acc[purchaserName].push(field);

        // Add the purchaser name to the list if it's not already included
        if (!purchasernamelist.includes(purchaserName)) {
          purchasernamelist.push(purchaserName);
        }

        return acc;
      }, {} as Record<string, typeof specificFields>);

      const stringFieldsByPurchaser = stringSpecificFields.reduce(
        (acc, field) => {
          const purchaserName = field.purchasername || "unknown";
          if (!acc[purchaserName]) {
            acc[purchaserName] = [];
          }
          acc[purchaserName].push(field);
          if (!purchasernamelist.includes(purchaserName)) {
            purchasernamelist.push(purchaserName);
          }
          return acc;
        },
        {} as Record<string, typeof stringSpecificFields>
      );
      // Initialize form values for specific fields with reset index for each purchaser
      Object.entries(fieldsByPurchaser).forEach(([purchaserName, fields]) => {
        fields.forEach((field, idx) => {
          let fieldKey = "";
          if (field.name !== "PurchaserInformationESigning.AddressForServicePostClosing" && field.name !== "PurchaserDetailsESigning.PurchaserSpousalDeclaration" && field.name !== "PurchaserDetailsESigning.PrincipalResidenceDeclaration") {
          fieldKey = `${field.name}-${purchaserName}-${idx}`;
          initialFormValues[fieldKey] =
            Array.isArray(field.value) && field.value[0]?.value === " [true]"
              ? "true"
              : "false";
          }
            if (field.name === "PurchaserDetailsESigning.PurchaserSpousalDeclaration") {
              for (let i = 0; i < 5; i++) {
                const tempFieldKey = `${field.name}-${purchaserName}-${i}`;
                initialFormValues[tempFieldKey] = "false";
              }
              if (Array.isArray(field.value)) {
                const optionIndex = getMatchingOptionIndex(purchaserName, field.value[0]?.value);
                initialFormValues[`${field.name}-${purchaserName}-${optionIndex}`] = "true";
              }
            }
            if (field.name === "PurchaserDetailsESigning.PrincipalResidenceDeclaration") {
              for (let i = 0; i < 2; i++) {
                const tempFieldKey = `${field.name}-${purchaserName}-${i}`;
                initialFormValues[tempFieldKey] = "false";
              }
              if (Array.isArray(field.value)) {
                const optionIndex = getMatchingOptionIndexForPrincipal(field.value[0]?.value);
                initialFormValues[`${field.name}-${purchaserName}-${optionIndex}`] = "true";
              }
            }

            if (field.name === "PurchaserInformationESigning.AddressForServicePostClosing") {
              for (let i = 0; i < 2; i++) {
                const tempFieldKey = `${field.name}-${purchaserName}-${i}`;
                initialFormValues[tempFieldKey] = "false";
                fieldKey = tempFieldKey;
              }
              if (Array.isArray(field.value)) {
                const optionIndex = getMatchingOptionIndexForAddressForServicePostClosing(field.value[0]?.value);
                initialFormValues[`${field.name}-${purchaserName}-${optionIndex}`] = "true";
              }
            }
          const additionalFields = additionalFieldsConfig[field.name];
          if (additionalFields) {
            additionalFields.forEach((label, fieldIdx) => {
              const additionalValue = Array.isArray(field.value)
                ? (field.value
                    .find((v) => v.name === label)
                    ?.value?.startsWith(" ")
                    ? field.value.find((v) => v.name === label)?.value.slice(1)
                    : field.value.find((v) => v.name === label)?.value) || ""
                : "";

              initialFormValues[`${fieldKey}-additional-${fieldIdx}`] =
                additionalValue;
            });
          }
        });
      });
      // Initialize form values for specific fields with reset index for each purchaser
      Object.entries(stringFieldsByPurchaser).forEach(
        ([purchaserName, fields]) => {
          fields.forEach((field) => {
            const fieldKey = `${field.name}-${purchaserName}`;
            const value =
              Array.isArray(field.value) && field.value[0]?.value
                ? field.value[0].value.startsWith(" ")
                  ? field.value[0].value.slice(1)
                  : field.value[0].value
                : "";
            initialFormValues[fieldKey] = value ? value : "";
          });
        }
      );
      setCheckboxFields([...checkboxFields]);
      setNormalFields([...normalFields]);
      setSpecificCheckboxFields([...specificFields]);
      setSpecificStringFields([...stringSpecificFields]);
      setFormValues(initialFormValues);
      console.log("purchasernamelist after setFormValues",purchasernamelist);
      // Set the purchaser list state
      setPurchaserList(purchasernamelist);
    };
    const fetchThirdPartyFiles = async () => {
      const thirdPartyDocInfo = await getThirdPartyDocInfo("-1");
      const thirdPartyDocInfoFiltered = thirdPartyDocInfo
        .filter((item) => item.MsgID.toString() === msgID)
        .sort((a, b) => a.DocumentName.localeCompare(b.DocumentName));
      setThirdPartyDocInfo(thirdPartyDocInfoFiltered);

      const status = thirdPartyDocInfoFiltered.map((doc) => doc.Uploaded);
      setThirdPartyDocUploadStatus(status);
    };

    fetchFields();
    fetchThirdPartyFiles();
  }, [propertyAddress]);

  useEffect(() => {
    let schedulePackageList: string[] = [];
    const fetchRemoteSigningSchedule = async () => {
      const ScheduleResponse = await axios.get(
        `/docsigning/info/remotesigning/schedule/${builderState.msgID}?SessionID=${sessionInfo.sid}`
      );
      if (ScheduleResponse.data.recordset.length > 0) {
        setSchedule(ScheduleResponse.data.recordset);
        setLawyerName(ScheduleResponse.data.recordset[0].SelectLawyer);
        
        // Parse PackageList - it might be a string that needs to be converted to array

        try {
          const packageListData = ScheduleResponse.data.recordset[0].PackageList;
          if (typeof packageListData === 'string') {
            // If it's a JSON string, parse it
            if (packageListData.startsWith('[') || packageListData.startsWith('{')) {
              schedulePackageList = JSON.parse(packageListData);
            } else {
              // If it's comma-separated, split it
              schedulePackageList = packageListData.split(',').map(item => item.trim());
            }
          } else {
            schedulePackageList = packageListData || [];
          }
        } catch (error) {
          console.error('Error parsing PackageList:', error);
          schedulePackageList = [];
        }
      }
        // Now fetch jurat package list and compare
        const fetchJuratPackageList = async () => {
          const JuratResponse = await axios.get(
            `/docsigning/info/remotesigning/fields/${builderState.msgID}?SessionID=${sessionInfo.sid}`
          );
          if (JuratResponse.data.data.files.length > 0) {
            setJuratPackageList(JuratResponse.data.data.files);
          }
          if (schedulePackageList.length > 0) {
            // Now we can safely compare since schedulePackageList is available
          const common = JuratResponse.data.data.files.filter(f => schedulePackageList.includes(f));
            setCommonFiles(common);
          }
        };
        
        fetchJuratPackageList();
      
    };

    if (builderState.msgID) {
      updateDocuments();
      fetchRemoteSigningSchedule();
    }
  }, [builderState.msgID]);

  useEffect(() => {
    const updatedFormData: EsignAskfieldsItemProps[] = [
      ...normalFields.map((field, idx) => ({
        title: field.name,
        value: " " + formValues[`formField${idx}`] || field.value,
      })),
      ...stringSpecificFields.map((field) => ({
        title: field.name,
        value: [
          {
            title: `${field.name}_status`,
            value: " " + formValues[`${field.name}-${field.purchasername}`],
          },
          {
            title: "purchasername",
            value: field.purchasername,
          },
        ],
      })),
      ...checkboxFields.map((field, idx) => {
        const additionalFields = Object.keys(formValues)
          .filter((key) => key.startsWith(`additionalField${idx}`))
          .map((key) => {
            const fieldIdx = key.split("-")[1]; // Extract the field index
            const fieldName = additionalFieldsConfig[field.name][fieldIdx]; // Get the field name
            return {
              title: fieldName,
              value: formValues[key],
            };
          });
          let fieldKey = "";
          if (field.name === "PurchaserDetailsESigning.HSTEligibility") {
            for (let i = 0; i < 2; i++) {
              const tempFieldKey = `${field.name}-${i}`;
              if (formValues[tempFieldKey] === "true") {
                fieldKey = tempFieldKey;
              }
            }
          }
          if (field.name === "PurchaserDetailsESigning.HSTEligibilitySimple") {
            for (let i = 0; i < 2; i++) {
              const tempFieldKey = `${field.name}-${i}`;
              if (formValues[tempFieldKey] === "true") {
                fieldKey = tempFieldKey;
              }
            }
          }
          if (field.name === "AssigneeDetailsESigning.AssigneeHSTEligibility") {
            for (let i = 0; i < 2; i++) {
              const tempFieldKey = `${field.name}-${i}`;
              if (formValues[tempFieldKey] === "true") {
                fieldKey = tempFieldKey;
              }
            }
          }
          if (field.name === "PurchaserDetailsESigning.OccupantDetails") {
            for (let i = 0; i < 4; i++) {
              const tempFieldKey = `${field.name}-${i}`;
              if (formValues[tempFieldKey] === "true") {
                fieldKey = tempFieldKey;
              }
            }
          }
      

        return {
          title: field.name,
          value: [
            {
              title: `${field.name}_status`,
              value:field.name === "PurchaserDetailsESigning.HSTEligibility"
                ? getHSTEligibilityOptions(true)[fieldKey.split('-').pop()]
                : field.name === "PurchaserDetailsESigning.HSTEligibilitySimple"
                ? getHSTEligibilitySimpleOptions()[fieldKey.split('-').pop()]
                : field.name === "AssigneeDetailsESigning.AssigneeHSTEligibility"
                ? getAssigneeHSTEligibilityOptions()[fieldKey.split('-').pop()]
                : field.name === "PurchaserDetailsESigning.OccupantDetails"
                ? getOccupantDetailsSubmitData()[fieldKey.split('-').pop()]
                : formValues[`checkboxField${idx}`] === "true"
                  ? " [true]"
                  : " [false]",
            },
            ...additionalFields,
            ...(field.name === "PurchaserDetailsESigning.OccupantDetails" && fieldKey.split('-').pop() !== "3"
            ? getOccupantDetailsAdditionalFieldsSubmitData(formValues, fieldKey) 
            : [])
          ],
        };
      }),
      ...Object.entries(
        specificFields.reduce((acc, field) => {
          const purchaserName = field.purchasername || "unknown";
          if (!acc[purchaserName]) {
            acc[purchaserName] = [];
          }
          acc[purchaserName].push(field);
          return acc;
        }, {} as Record<string, typeof specificFields>)
      ).flatMap(([purchaserName, fields]) =>
        (
          fields as Array<{ name: string; purchasername?: string; value: any }>
        ).map((field, idx) => {

          let fieldKey = `${field.name}-${purchaserName}-${idx}`;
          if (field.name === "PurchaserDetailsESigning.PurchaserSpousalDeclaration") {
            for (let i = 0; i < 5; i++) {
              const tempFieldKey = `${field.name}-${purchaserName}-${i}`;
              if (formValues[tempFieldKey] === "true") {
                fieldKey = tempFieldKey;
              }
            }
          }
          if (field.name === "PurchaserDetailsESigning.PrincipalResidenceDeclaration") {
            for (let i = 0; i < 2; i++) {
              const tempFieldKey = `${field.name}-${purchaserName}-${i}`;
              if (formValues[tempFieldKey] === "true") {
                fieldKey = tempFieldKey;
              }
            }
          }
          if (field.name === "PurchaserInformationESigning.AddressForServicePostClosing") {
            for (let i = 0; i < 2; i++) {
              const tempFieldKey = `${field.name}-${purchaserName}-${i}`;
              if (formValues[tempFieldKey] === "true") {
                fieldKey = tempFieldKey;
              }
            }
          }
          
          const additionalFields = Object.keys(formValues)
            .filter((key) => key.startsWith(`${fieldKey}-additional`))
            .map((key) => {
              const parts = key.split("-");
              const fieldIdx = parts[parts.length - 1]; // Extract the last part as the field index
              const fieldName = additionalFieldsConfig[field.name]?.[fieldIdx]; // Get the field name
              return {
                title: fieldName,
                value: " " + formValues[key],
              };
            });
          return {
            title: field.name,
            value: [
              {
                title: `${field.name}_status`,
                value: field.name === "PurchaserDetailsESigning.PurchaserSpousalDeclaration"
                                      ? getSpousalDeclarationOptions(purchaserName)[fieldKey.split('-').pop()]
                                      : field.name === "PurchaserInformationESigning.AddressForServicePostClosing"
                                      ? fieldKey.split('-').pop() === "0" ? propertyAddress : ""
                                      : field.name === "PurchaserDetailsESigning.PrincipalResidenceDeclaration"
                                      ? getPrincipalResidenceDeclarationOptions()[fieldKey.split('-').pop()]
                                      : formValues[fieldKey] === "true" ? " [true]" : " [false]", 
              },
              ...(field.name === "PurchaserInformationESigning.AddressForServicePostClosing" && fieldKey.split('-').pop() === "0"
              ? [{ title: "Enter Address for Service", value: "" }]
              : []),
              ...additionalFields,
              {
                title: "purchasername",
                value: purchaserName,
              },
            ],
          };
        })
      ),
      // Add ClaimantName if rebate claimant is selected
      ...(claimantFields.length > 1 && formValues["rebateClaimantSelection"]
        ? (() => {
            const selectedClaimant = formValues["rebateClaimantSelection"];
            let convertedValue = selectedClaimant;
            
            // Check if the value contains a comma (indicating "lastname, firstname" format)
            if (selectedClaimant.includes(', ')) {
              const [lastName, firstName] = selectedClaimant.split(', ');
              convertedValue = `${firstName} ${lastName}`;
            }
            
            return [{
              title: "ClaimantName",
              value: convertedValue
            }];
          })()
        : []
      ),
    ];
    dispatch(setEsignAskfieldsForm(updatedFormData));
  }, [formValues, claimantFields]);

  const updateDocuments = async () => {
    updateSellerDocs();
    // updateBuyerDocs();
  };

  const updateSellerDocs = async () => {
    const esign = true;
    const docs = await getBuilderDocs(builderState.msgID, sessionInfo, esign);
    const baseURL = window.location.origin;
    const StatusResponse = await axios.get(
      `${baseURL}/docsigning/info/inbox/status/${builderState.msgID}?SessionID=${sessionInfo.sid}`
    );

    const statusData = StatusResponse.data.data.recordset;

    for (let i = 0; i < docs.publicFiles?.length; i++) {
      const file = docs.publicFiles[i];
      file.type = "Esign";

      const statusEntry = statusData.find(
        (entry: {
          PostingCaption: string;
          SignStatus: string;
          SignDetails: string;
        }) => entry.PostingCaption === file.filename.replace(/\.pdf$/, "")
      );

      if (statusEntry) {
        file.PostingDate = statusEntry.PostingDate || "";
        file.note = statusEntry.Note || "";
        file.signStatus = statusEntry.SignStatus;

        // Parse SignDetails JSON to extract signedPath
        try {
          const signDetails = JSON.parse(statusEntry.SignDetails);
          file.signedPath = signDetails.signedPath || "";
        } catch (error) {
          console.error("Error parsing SignDetails JSON:", error);
          file.signedPath = "";
        }
      }
    }
    setSellerDocs(docs.publicFiles || []);
  };

  const renderAdditionalFieldsforOccupantDetails = (fieldName: string) => {

    if (fieldName === "PurchaserDetailsESigning.OccupantDetails") {
      for (let i = 0; i < 4; i++) {
        const tempFieldKey = `${fieldName}-${i}`;
        const additionalFieldLabels = additionalFieldsForOccupantDetailsConfig[tempFieldKey];
        if (formValues[tempFieldKey] === "true" && additionalFieldLabels) {
          return additionalFieldLabels.map((label, fieldIdx) => (
            <Row className="mb-3">
              <Col md={4} key={`${tempFieldKey}-additional-${fieldIdx}`}>
                <Form.Group controlId={`${tempFieldKey}-additional-${fieldIdx}`}>
                  <Form.Label>{label}</Form.Label>
                  <Form.Control
                    type="text"
                    value={formValues[`${tempFieldKey}-additional-${fieldIdx}`] || ""}
                    placeholder={NormalFieldsPlaceholders[label]}
                    onChange={(e) => {
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        [`${tempFieldKey}-additional-${fieldIdx}`]: e.target.value,
                      }))
                      dispatch(setIndicators("IsPageDirty", true))
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
          ));
          
        }
      }
      return null;
    }
  }

  // Helper function to render additional fields
  const renderAdditionalFields = (fieldName: string, idx: number) => {
    const additionalFieldLabels = additionalFieldsConfig[fieldName];
    if (fieldName !== "PurchaserDetailsESigning.OccupantDetails" && additionalFieldLabels && formValues[`checkboxField${idx}`] === "true") {
      return additionalFieldLabels.map((label, fieldIdx) => (
        <Row className="mb-3">
          <Col md={4} key={`additionalField${idx}-${fieldIdx}`}>
            <Form.Group controlId={`additionalField${idx}-${fieldIdx}`}>
              <Form.Label>{label}</Form.Label>
              <Form.Control
                type="text"
                value={formValues[`additionalField${idx}-${fieldIdx}`] || ""}
                onChange={(e) => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    [`additionalField${idx}-${fieldIdx}`]: e.target.value,
                  }))
                  dispatch(setIndicators("IsPageDirty", true))
                }}
              />
            </Form.Group>
          </Col>
        </Row>
      ));
    }
    return null;
  };

  // Function to render additional fields for a specific purchaser
  const renderPurchaserAdditionalFields = (
    fieldName: string,
    purchaserName: string,
    idx: number
  ) => {
    const additionalFieldsConfig: { [key: string]: string[] } = {
      "Citizenship.PurchaserIsNotNonResident": ["Country of Residence"],
      "PurchaserInformationESigning.AddressForServicePostClosing": ["Enter Address for Service"],
      // Add more mappings as needed
    };
    const additionalFieldLabels = additionalFieldsConfig[fieldName];
    let fieldKey = `${fieldName}-${purchaserName}-${idx}`;
    if (fieldName === "PurchaserInformationESigning.AddressForServicePostClosing") {
      fieldKey = `${fieldName}-${purchaserName}-1`;
    }
    if (additionalFieldLabels && formValues[fieldKey] === "true") {
      return additionalFieldLabels.map((label, fieldIdx) => (
        <Col md={8} key={`${fieldKey}-additional-${fieldIdx}`}>
          <Form.Group controlId={`${fieldKey}-additional-${fieldIdx}`}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
              type="text"
              placeholder={fieldName === "PurchaserInformationESigning.AddressForServicePostClosing" ? "E.g., 123 Street Road, Toronto ON, M7J 0G4" : ""}
              value={formValues[`${fieldKey}-additional-${fieldIdx}`] || ""}
              onChange={(e) => {
                setFormValues((prevValues) => ({
                  ...prevValues,
                  [`${fieldKey}-additional-${fieldIdx}`]: e.target.value,
                }))
                dispatch(setIndicators("IsPageDirty", true))
              }}
            />
          </Form.Group>
        </Col>
      ));
    }
    return null;
  };

  const handleRemoteSigningClick = async () => {

    const {isAnyFieldEmpty, isAnyRelevantGroupEmpty} = checkIfAllFieldsAreFilled();
    
    // Check if rebate claimant is selected when required
    if (claimantFields.length > 1 && !formValues["rebateClaimantSelection"]) {
      alert("Please select a HST/GST New Home Rebate Claimant to proceed");
      return;
    }
    
    if (isAnyFieldEmpty || isAnyRelevantGroupEmpty) {
      alert("Please complete the fields under 'General Information' to initiate eSigning");
      return;
    }
    for (let i = 0; i < purchaserList.length; i++) {
      if (formValues["PurchaserInformationESigning.AddressForServicePostClosing-" + purchaserList[i] + "-0"] === "true" && (!propertyAddress || propertyAddress === ", Ontario")) {
        setShowModal(true);
        return;
      }
    }
    try {
      if (commonFiles.length > 0) {
        setShowJuratModal(true);
        setIsRemoteSigning(true);
      } else {
        setLoading(true)
        await handleSubmitForms(builderState.msgID, null, true);
        const currentUrl = window.location.pathname;
        const drParam = currentUrl.includes('/dr/') ? '&dr=true' : '';
        window.open('/' + process.env.REACT_APP_CLIENT_PORTAL_FRONTEND + '/joinRSLawyer' +
              '?SessionID=' + sessionInfo.sid +
              '&province=' + 'ON' +
              '&appId=' + builderState.appId +
              '&meetingid=' + schedule[0]?.MeetingID +
              '&shortcode=' + schedule[0]?.Shortcode +
               drParam)
        setLoading(false);
      }
      setGlobalPreviewDisabled(true);
    } catch (error) {
      // Handle error (show notification, etc.)
      console.error(error);
    }
  };
  // Function to handle form field changes
  const handleFieldChange = (idx: number, value: string) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [`formField${idx}`]: value,
    }));
    dispatch(setIndicators("IsPageDirty", true))
  };

  const handleCheckboxChange = (idx: number, value: boolean) => {
    setFormValues((prevValues) => {
      const updatedValues = {
        ...prevValues,
        [`checkboxField${idx}`]: value ? "true" : "false",
      };

      // Always reset additional fields when checkbox status changes
      const additionalFields = additionalFieldsConfig[checkboxFields[idx].name];
      if (additionalFields) {
        additionalFields.forEach((_, fieldIdx) => {
          updatedValues[`additionalField${idx}-${fieldIdx}`] = "";
        });
      }
      dispatch(setIndicators("IsPageDirty", true))
      return updatedValues;
    });
  };

  const checkIfAllFieldsAreFilled = () => {
    // Check if any value in formData is empty
    const textInputs = document.querySelectorAll<HTMLInputElement>('input[type="text"]');
    // Check if any text input field is empty and print each value
    const isAnyFieldEmpty = Array.from(textInputs).some(input => {
      return input.value.trim() === "";
    });

    const relevantPrefixes = [
      "PurchaserDetailsESigning.PurchaserSpousalDeclaration",
      "PurchaserInformationESigning.AddressForServicePostClosing",
      "PurchaserDetailsESigning.PrincipalResidenceDeclaration",
      "PurchaserDetailsESigning.HSTEligibility",
      "PurchaserDetailsESigning.HSTEligibilitySimple",
      "PurchaserDetailsESigning.OccupantDetails",
      "AssigneeDetailsESigning.AssigneeHSTEligibility"
    ];
    let isAnyRelevantGroupEmpty = false;
    // Check at least once even when purchaserList is empty (e.g. no purchasers yet)
    const listToCheck = purchaserList.length > 0 ? purchaserList : [undefined];
    listToCheck.forEach((purchaserName) => {
      if (!isAnyRelevantGroupEmpty) {
        isAnyRelevantGroupEmpty = relevantPrefixes.some(prefix => {
          // Filter keys that start with the prefix
          let keysWithPrefix: string[] = [];
          if (prefix === "PurchaserDetailsESigning.PurchaserSpousalDeclaration" || prefix === "PurchaserDetailsESigning.OccupantDetails" || prefix === "AssigneeDetailsESigning.AssigneeHSTEligibility" || prefix === "PurchaserDetailsESigning.HSTEligibilitySimple") {
            keysWithPrefix = Object.keys(formValues).filter(key => key.startsWith(prefix));
          } else {
            keysWithPrefix = Object.keys(formValues).filter(key => key.startsWith(prefix + "-" + (purchaserName ?? "")));
          }
          let isGroupNotEmpty = true;
          // Check if any of these keys have a value of 'true'
          if (keysWithPrefix.length > 0) {
            isGroupNotEmpty = keysWithPrefix.some(key => formValues[key] === "true");
          }
          return !isGroupNotEmpty;
        });
      }
    });
    return {isAnyFieldEmpty, isAnyRelevantGroupEmpty};
  }

  const StartinpesonJurat = (fileName: string) => {
    const {isAnyFieldEmpty, isAnyRelevantGroupEmpty} = checkIfAllFieldsAreFilled();
    
    // Check if rebate claimant is selected when required
    if (claimantFields.length > 1 && !formValues["rebateClaimantSelection"]) {
      alert("Please select a HST/GST New Home Rebate Claimant to proceed");
      return;
    }
    
    // Combine both checks
    if (isAnyFieldEmpty || isAnyRelevantGroupEmpty) {
      alert("Please complete the fields under 'General Information' to initiate eSigning");
      return;
    }
    for (let i = 0; i < purchaserList.length; i++) {
      if (formValues["PurchaserInformationESigning.AddressForServicePostClosing-" + purchaserList[i] + "-0"] === "true" && (!propertyAddress || propertyAddress === ", Ontario")) {
        setShowModal(true);
        return;
      }
    }
    setShowJuratModal(true);
    setIsRemoteSigning(false);
    setJuratFileName(fileName);
  }

  const handleSubmitForms = async (msgID: string, fileName?: string, remoteSigning?: boolean) => {
    
    const {isAnyFieldEmpty, isAnyRelevantGroupEmpty} = checkIfAllFieldsAreFilled();
    
    // Check if rebate claimant is selected when required
    if (claimantFields.length > 1 && !formValues["rebateClaimantSelection"]) {
      alert("Please select a HST/GST New Home Rebate Claimant to proceed");
      return;
    }
    
    // Combine both checks
    if (isAnyFieldEmpty || isAnyRelevantGroupEmpty) {
      alert("Please complete the fields under 'General Information' to initiate eSigning");
      return;
    }
    for (let i = 0; i < purchaserList.length; i++) {
      if (formValues["PurchaserInformationESigning.AddressForServicePostClosing-" + purchaserList[i] + "-0"] === "true" && (!propertyAddress || propertyAddress === ", Ontario")) {
        setShowModal(true);
        return;
      }
    }
    try {
      const baseURL = window.location.origin;
      
      await axios.post(
        `${baseURL}/docsigning/info/inbox/fields/${msgID}?SessionID=${sessionInfo.sid}`,
        { fields: formData },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
    if (!remoteSigning) {
    // Open a new window with the e-signing URL
    const baseURL = window.location.origin;
    const eSignUrl = `${baseURL}/esign/?SessionID=${sessionInfo.sid}&messageID=${msgID}&FileName=${fileName}`;
    window.open(eSignUrl, "_blank", "noopener,noreferrer");
    }
  };

  async function getDocumentFileds(msgID: string) {
    const baseURL = window.location.origin;
    const response = await axios.get(
      `${baseURL}/docsigning/info/inbox/fields/${msgID}?SessionID=${sessionInfo.sid}`
    );
    const fieldsData = response.data;
    return fieldsData.data.fields;
  }

  function getSpousalDeclarationOptions(purchaserName, displayname = false) {
    return [
      "We are spouses of one another.",
      `I, ${purchaserName}, am not a spouse.`,
      "I am a spouse, the Property is not ordinarily occupied by me or my spouse, who is not separated from me, as our matrimonial residence.",
      "I am a spouse. My spouse has released Part II rights by a separation agreement.",
      displayname
        ? "I am a spouse, the other person consenting on this purchase is my spouse."
        : "I am a spouse. The person consenting below is my spouse."
    ];
  }

  function getPrincipalResidenceDeclarationOptions() {
    return [
      `I covenant that the above-noted Unit is being purchased by me/us or for a person who is a blood
      relationship [as defined in the Income Tax Act (Canada)] for our personal use and not for investment
      or speculative purposes.`,
      "I covenant that the above-noted Unit will not be occupied by me as my principal residence."
    ];
  }

  function getHSTEligibilityOptions(displayname?: boolean) {
    return [
      displayname
        ? "The undersigned, hereby confirms its representation, upon which representation the Vendor is relying, that the Unit is being purchased for the Purchaser's own personal use and not for investment or speculative purposes and will occupy the Unit in accordance with the provisions of the Agreement of Purchase and Sale and the proposed Declaration, By-laws and rules of the proposed condominium. The Purchaser further confirms that the only person(s) other than the Purchaser who will occupy the Unit from and after the Confirmed Occupancy Date will be the Purchaser and his relatives (as prescribed under the Excise Tax Act)."
        : "Purchasers are eligible for the HST rebate.",
      "Purchasers are not eligible for the HST rebate."
    ];
  }
  function getAssigneeHSTEligibilityOptions() {
    return [
      "Assignee is eligible for the HST rebate.",
      "Assignee is NOT eligible for the HST rebate."
    ];
  }
  function getHSTEligibilitySimpleOptions() {
    return [
      "Eligible for the HST Rebate.",
      "NOT eligible for the HST Rebate."
    ];
  }

  function getOccupantDetailsAdditionalFieldsSubmitData(formValues: any, fieldKey: string) {
    const fieldKeySplit = fieldKey.split('-');
    const index = parseInt(fieldKeySplit[fieldKeySplit.length - 1] || '0', 10);
    
    const options = [
      [{ title: "Name", value: `Name: ${formValues[`${fieldKey}-additional-0`] || ''}` },
      { title: "Relationship", value: `Relationship of Occupant(s) to all Purchaser(s): ${formValues[`${fieldKey}-additional-1`] || ''}` }],
      [{ title: "Name", value: `Name: ${formValues[`${fieldKey}-additional-0`] || ''}` },
      { title: "Relationship", value: `Relationship of Occupant(s) to all Purchaser(s): ${formValues[`${fieldKey}-additional-1`] || ''}` }],
      [{ title: "Name", value: `Name: ${formValues[`${fieldKey}-additional-0`] || ''}` }]
    ];
    
    return options[index] || options[0]; // fallback to first option if index is out of bounds
  }

  function getOccupantDetailsSubmitData() {
    return [
      `The Purchaser(s) and any other occupants`,
      `Relation(s) to all Purchaser(s) (insert the name(s) and relationship(s) below)`,
      `Tenant(s) (insert the names of all Tenants below)`,
      "No Occupant"
    ];
  }

  function setOccupantDetailsAdditionalFields(formValues: any, fieldValue: any, optionIndex: number, fieldKey: string) {
    if (optionIndex === 0) {
      formValues[`${fieldKey}-${optionIndex}-additional-0`] = fieldValue[2]?.value?.split(':')[1]?.trim() || '';
      formValues[`${fieldKey}-${optionIndex}-additional-1`] = fieldValue[3]?.value?.split(':')[1]?.trim() || '';
    } else if (optionIndex === 1) {
      formValues[`${fieldKey}-${optionIndex}-additional-0`] = fieldValue[2]?.value?.split(':')[1]?.trim() || '';
      formValues[`${fieldKey}-${optionIndex}-additional-1`] = fieldValue[3]?.value?.split(':')[1]?.trim() || '';
    } else if (optionIndex === 2) {
      formValues[`${fieldKey}-${optionIndex}-additional-0`] = fieldValue[1]?.value?.split(':')[1]?.trim() || '';
    }
    
  }

  function getOccupantDetailsOptions() {
    return [
      "The Purchasers",
      "Occupant related to Purchaser(s)",
      "Tenant",
      "No Occupant"
    ];
  }

  function getAddressForServicePostClosingOptions() {
    return [
      "Purchase Property is the Address for Service",
      "Purchase Property is NOT the Address for Service"
    ];
  }
  

  function getMatchingOptionIndex(purchaserName, valueToMatch) {
    const options = getSpousalDeclarationOptions(purchaserName);
    return options.findIndex(option => option === valueToMatch);
  }

  function getMatchingOptionIndexForPrincipal(valueToMatch) {
    const options = getPrincipalResidenceDeclarationOptions();
    return options.findIndex(option => option === valueToMatch);
  }

  function getMatchingOptionIndexForAddressForServicePostClosing(valueToMatch) {
    if (propertyAddress && valueToMatch === propertyAddress) {
      return 0;
    } else {
      return 1;
    }
  }

  function getMatchingOptionIndexForHSTEligibility(valueToMatch) {
    if (valueToMatch === "Purchasers are eligible for the HST rebate.") {
      return 0;
    }  else if (valueToMatch === "Purchasers are not eligible for the HST rebate.") {
      return 1;
    }
  }

  function getMatchingOptionIndexForHSTEligibilitySimple(valueToMatch) {
    if (valueToMatch === "Eligible for the HST Rebate.") {
      return 0;
    }  else if (valueToMatch === "NOT eligible for the HST Rebate.") {
      return 1;
    }
  }

  function getMatchingOptionIndexForAssigneeHSTEligibility(valueToMatch) {
    if (valueToMatch === "Assignee is eligible for the HST rebate.") {
      return 0;
    }  else if (valueToMatch === "Assignee is NOT eligible for the HST rebate.") {
      return 1;
    }
  }

  function getMatchingOptionIndexForOccupantDetails(valueToMatch) {
    if (valueToMatch === "The Purchaser(s) and any other occupants") {
      return 0;
    }  else if (valueToMatch === "Relation(s) to all Purchaser(s) (insert the name(s) and relationship(s) below)") {
      return 1;
    } else if (valueToMatch === "Tenant(s) (insert the names of all Tenants below)") {
      return 2;
    } else if (valueToMatch === "No Occupant") {
      return 3;
    }
  }

  async function getThirdPartyDocInfo(projectId: string) {
    const baseURL = window.location.origin;
    try {
      const response = await axios.get(
        `${baseURL}/docsigning/info/inbox/getAllThirdPartyInfo/${projectId}?SessionID=${sessionInfo.sid}`
      );
      const thirdPartyDocInfo = response.data.data.recordsets[0];
      return thirdPartyDocInfo;
    } catch (error) {
      console.error("Error fetching third party doc info:", error);
      return []; // Return an empty result
    }
  }

  function sellerTableBody(): JSX.Element[] {
    const docsData = sellerDocs;
    return docsData.map((doc: BuilderDocType, index: number) => (
      <BuilderDocumentRow
        key={index}
        FileName={doc.filename}
        Timestamp={doc.PostingDate}
        msgID={builderState.msgID} // Pass msgID
        signStatus={doc.signStatus}
        note={doc.note}
        onStartEsigning={(msgID, fileName, remoteSigning) =>
          handleSubmitForms(msgID, fileName, remoteSigning)
        } // Pass the function
        sid={sessionInfo.sid}
        JuratPackageList={JuratPackageList}
        StartinpesonJurat={() => StartinpesonJurat(doc.filename)}
      />
    ));
  }
  const allDocsSigned = sellerDocs.every((doc) => doc.signStatus === true);
  return (
    <>
      <BuilderBanner
        sessionInfo={sessionInfo}
        msgID={builderState.msgID}
        showImport={false}
      />
      <Card>
        {!(
          normalFields.length === 0 &&
          checkboxFields.length === 0 &&
          specificFields.length === 0 &&
          stringSpecificFields.length === 0
        ) ? (
          <Card.Header>
            <h2>General Information</h2>
          </Card.Header>
        ) : (
            <Alert variant="info">There are no documents that need to be edited.</Alert>
        )}
        
        {!allDocsSigned ? (
            <Card.Body>
            <Form>
                <Row className="mb-3">
                    {normalFields.map((field, idx) => (
                    <Col md={4} key={idx} className="mb-3">
                        <Form.Group controlId={`formField${idx}`}>
                        <Form.Label>{fieldDisplayNames[field.name]}</Form.Label>
                        <Form.Control
                            type="text"
                            defaultValue={formValues[`formField${idx}`]}
                            readOnly={!field.editable}
                            placeholder={
                            !formValues[`formField${idx}`] && NormalFieldsPlaceholders[field.name]
                            ? NormalFieldsPlaceholders[field.name]
                            : undefined
                            }
                            onChange={(e) => handleFieldChange(idx, e.target.value)}
                        />
                        </Form.Group>
                    </Col>
                    ))}
                </Row>

                 {/* HST/GST Rebate Claimant Selection */}
                 {claimantFields.length > 1 && (
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group controlId="rebateClaimantSelection">
                        <Form.Label>HST/GST New Home Rebate Claimant:</Form.Label>
                        <Dropdown>
                          <Dropdown.Toggle 
                            variant="outline-secondary" 
                            id="dropdown-rebate-claimant"
                            style={{ width: '100%', textAlign: 'left' }}
                          >
                            {formValues["rebateClaimantSelection"] || "Select a claimant..."}
                          </Dropdown.Toggle>
                          <Dropdown.Menu style={{ width: '100%', maxHeight: '200px', overflowY: 'auto' }}>
                            {claimantFields.map((claimant, index) => (
                              <Dropdown.Item 
                                key={index} 
                                onClick={() => {
                                  setFormValues(prev => ({
                                    ...prev,
                                    rebateClaimantSelection: claimant.value
                                  }));
                                  dispatch(setIndicators("IsPageDirty", true));
                                }}
                              >
                                {claimant.value}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </Form.Group>
                    </Col>
                  </Row>
                )}

                {checkboxFields.length > 0 && (
                    <Card.Title>Select all that apply:</Card.Title>
                )}

                {checkboxFields.map((field, idx) => (
                    <>
                    <Row key={`checkbox-${idx}`}>
                        <Col md={12}>
                        <Form.Group controlId={`checkboxField${idx}`}>
                            {field.name === "PurchaserDetailsESigning.HSTEligibility" ? ( 
                            <>
                            <Form.Label>{fieldDisplayNames[field.name]}</Form.Label>
                            {getHSTEligibilityOptions(false).map((label, optionIdx)  => (
                                <Form.Check
                                key={`${field.name}-${optionIdx}`}
                                type="checkbox"
                                label={label}
                                checked={formValues[`${field.name}-${optionIdx}`] === "true"}
                                onChange={() => {
                                    // Uncheck all other checkboxes
                                    const newFormValues = { ...formValues };
                                    for (let i = 0; i <2;i++) {
                                    newFormValues[`${field.name}-${i}`] = "false";
                                    }
                                    // Check the selected checkbox
                                    newFormValues[`${field.name}-${optionIdx}`] = "true";
                                    setFormValues(newFormValues);
                                    dispatch(setIndicators("IsPageDirty", true));
                                }}
                                />
                            ))}
                            </>
                            ) : field.name === "PurchaserDetailsESigning.HSTEligibilitySimple" ? ( 
                            <>
                            <Form.Label>{ fieldDisplayNames[field.name] }</Form.Label>
                            { getHSTEligibilitySimpleOptions().map((label, optionIdx)  => (
                                <Form.Check
                                key={ `${field.name}-${optionIdx}` }
                                type="checkbox"
                                label={ label }
                                checked={ formValues[`${field.name}-${optionIdx}`] === "true" }
                                onChange={ () => {
                                    // Uncheck all other checkboxes
                                    const newFormValues = { ...formValues };
                                    for (let i = 0; i < 2; i++) {
                                    newFormValues[`${field.name}-${i}`] = "false";
                                    }
                                    // Check the selected checkbox
                                    newFormValues[`${field.name}-${optionIdx}`] = "true";
                                    setFormValues(newFormValues);
                                    dispatch(setIndicators("IsPageDirty", true));
                                }}
                                />
                            ))}
                            </>
                            ) : field.name === "AssigneeDetailsESigning.AssigneeHSTEligibility" ? ( 
                            <>
                            <Form.Label>{ fieldDisplayNames[field.name] }</Form.Label>
                            { getAssigneeHSTEligibilityOptions().map((label, optionIdx)  => (
                                <Form.Check
                                key={ `${field.name}-${optionIdx}` }
                                type="checkbox"
                                label={ label }
                                checked={ formValues[`${field.name}-${optionIdx}`] === "true" }
                                onChange={ () => {
                                    // Uncheck all other checkboxes
                                    const newFormValues = { ...formValues };
                                    for (let i = 0; i < 2; i++) {
                                    newFormValues[`${field.name}-${i}`] = "false";
                                    }
                                    // Check the selected checkbox
                                    newFormValues[`${field.name}-${optionIdx}`] = "true";
                                    setFormValues(newFormValues);
                                    dispatch(setIndicators("IsPageDirty", true));
                                } }
                                />
                            )) }
                            </>
                            ) : field.name === "PurchaserDetailsESigning.OccupantDetails" ? ( 
                            <>
                            <Form.Label>{fieldDisplayNames[field.name]}</Form.Label>
                            {getOccupantDetailsOptions().map((label, optionIdx)  => (
                                <React.Fragment key={`${field.name}-${optionIdx}`}>
                                <Form.Check
                                    type="checkbox"
                                    label={label}
                                    checked={formValues[`${field.name}-${optionIdx}`] === "true"}
                                    onChange={() => {
                                    // Uncheck all other checkboxes
                                    const newFormValues = { ...formValues };
                                    for (let i = 0; i < 4; i++) {
                                        newFormValues[`${field.name}-${i}`] = "false";
                                    }
                                    // Check the selected checkbox
                                    newFormValues[`${field.name}-${optionIdx}`] = "true";
                                    setFormValues(newFormValues);
                                    dispatch(setIndicators("IsPageDirty", true));
                                    }}
                                />
                                {/* Conditionally render additional fields after this checkbox */}
                                {formValues[`${field.name}-${optionIdx}`] === "true" && renderAdditionalFieldsforOccupantDetails(field.name)}
                                </React.Fragment>
                            ))}
                            </>
                            ) :(
                            <Form.Check
                                type="checkbox"
                                label={fieldDisplayNames[field.name]}
                                checked={formValues[`checkboxField${idx}`] === "true"}
                            onChange={(e) => {
                                const newValue = e.target.checked;
                                handleCheckboxChange(idx, newValue);
                            }}
                            style={{
                                color:
                                formValues[`checkboxField${idx}`] === "true"
                                    ? "blue"
                                    : "inherit",
                            }}
                            />
                            )}
                        </Form.Group>
                        </Col>
                    </Row>

                    {renderAdditionalFields(field.name, idx)}
                    </>
                ))}
            </Form>

            <Row>
              {purchasers.map((purchaser, index) => {
                const purchaserStringFields = stringSpecificFields.filter(
                  (field) =>
                    field.purchasername.toLowerCase() ===
                    purchaser.name.toLowerCase()
                );
                const purchaserFields = specificFields.filter(
                  (field) =>
                    field.purchasername.toLowerCase() ===
                    purchaser.name.toLowerCase()
                );
                // Skip rendering if there are no specific fields for the purchaser
                if (
                  purchaserFields.length === 0 &&
                  purchaserStringFields.length === 0
                )
                  return null;

                return (
                  <Col key={index} className="mt-3 col-6">
                    <Card.Title>{purchaser.name}</Card.Title>
                    <Form>
                      {purchaserStringFields.map((field) => {
                        const fieldKey = `${field.name}-${purchaser.name}`;
                        const isBirthdateField = field.name === "PurchaserInformationESigning.PurchaserBirthdate";
                        
                        return (
                          <Row key={`specific-string-${fieldKey}`}>
                            <Col md={12}>
                              <Form.Group controlId={fieldKey} style={{ marginTop: '10px' }}>
                                <Form.Label>
                                  {fieldDisplayNames[field.name]}
                                </Form.Label>
                                {isBirthdateField ? (
                                  <InputGroup>
                                    <InputGroup.Text
                                      onClick={(e) => {
                                        e.currentTarget.nextElementSibling?.getElementsByTagName("input")[0]?.dispatchEvent(new Event("click", {
                                          bubbles: true,
                                          cancelable: true,
                                        }));
                                      }}
                                      style={{
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <i className="fa-solid fa-calendar-days" />
                                    </InputGroup.Text>
                                    <ReactDatePicker
                                      dateFormat="yyyy/MM/dd"
                                      selected={parseDateYYYYMMDD(formValues[fieldKey])}
                                      onChange={(date: Date | null) => {
                                        const newValue = date ? formatDateYYYYMMDD(date) : '';
                                        setFormValues((prevValues) => {
                                          const updatedValues = {
                                            ...prevValues,
                                            [fieldKey]: newValue,
                                          };
                                          dispatch(setIndicators("IsPageDirty", true));
                                          return updatedValues;
                                        });
                                      }}
                                      placeholderText={
                                        !formValues[fieldKey] && PurchaserFieldsPlaceholders[field.name]
                                          ? PurchaserFieldsPlaceholders[field.name]
                                          : undefined
                                      }
                                      showYearDropdown
                                      showMonthDropdown
                                      yearDropdownItemNumber={100}
                                      scrollableYearDropdown
                                      maxDate={new Date()}
                                      className="form-control"
                                    />
                                  </InputGroup>
                                ) : (
                                  <Form.Control
                                    type="text"
                                    defaultValue={formValues[fieldKey]}
                                    readOnly={!field.editable}
                                    placeholder={
                                      !formValues[fieldKey] && PurchaserFieldsPlaceholders[field.name]
                                      ? PurchaserFieldsPlaceholders[field.name]
                                      : undefined
                                    }
                                    onChange={(e) => {
                                      const newValue = e.target.value;
                                      setFormValues((prevValues) => {

                                        const updatedValues = {
                                          ...prevValues,
                                          [fieldKey]: newValue,
                                        };
                                        dispatch(setIndicators("IsPageDirty", true));
                                        return updatedValues;
                                      });
                                    }}
                                  />
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                        );
                      })}

                    {purchaserFields.map((field, idx) => {
                      const fieldKey = `${field.name}-${purchaser.name}`;
                      return (
                        <Row key={`specific-checkbox-${fieldKey}`}>
                          <Col md={12}>
                            <Form.Group controlId={`specificCheckboxField-${fieldKey}`} style={{ marginTop: '10px' }}>
                              {field.name === "PurchaserDetailsESigning.PurchaserSpousalDeclaration" ? (
                                <>
                                  <Form.Label>{fieldDisplayNames[field.name]}</Form.Label>
                                  {getSpousalDeclarationOptions(purchaser.name, true).map((label, optionIdx)  => (
                                    <Form.Check
                                      key={`${fieldKey}-${optionIdx}`}
                                      type="checkbox"
                                      label={label}
                                      checked={formValues[`${fieldKey}-${optionIdx}`] === "true"}
                                      onChange={() => {
                                        // Uncheck all other checkboxes
                                        const newFormValues = { ...formValues };
                                        for (let i = 0; i < 5; i++) {
                                          newFormValues[`${fieldKey}-${i}`] = "false";
                                        }
                                        // Check the selected checkbox
                                        newFormValues[`${fieldKey}-${optionIdx}`] = "true";
                                        setFormValues(newFormValues);
                                        dispatch(setIndicators("IsPageDirty", true));
                                      }}
                                    />
                                  ))}
                                </>
                              )
                              : field.name === "PurchaserDetailsESigning.PrincipalResidenceDeclaration" ? (
                                <>
                                  <Form.Label>{fieldDisplayNames[field.name]}</Form.Label>
                                  {getPrincipalResidenceDeclarationOptions().map((label, optionIdx)  => (
                                    <Form.Check
                                      key={`${fieldKey}-${optionIdx}`}
                                      type="checkbox"
                                      label={label}
                                      checked={formValues[`${fieldKey}-${optionIdx}`] === "true"}
                                      onChange={() => {
                                        // Uncheck all other checkboxes
                                        const newFormValues = { ...formValues };
                                        for (let i = 0; i < 2; i++) {
                                          newFormValues[`${fieldKey}-${i}`] = "false";
                                        }
                                        // Check the selected checkbox
                                        newFormValues[`${fieldKey}-${optionIdx}`] = "true";
                                        setFormValues(newFormValues);
                                        dispatch(setIndicators("IsPageDirty", true));
                                      }}
                                    />
                                  ))}
                                </>
                              )
                              
                              : field.name === "PurchaserInformationESigning.AddressForServicePostClosing" ? (
                                <>
                                  <Form.Label>{fieldDisplayNames[field.name]}</Form.Label>
                                  {getAddressForServicePostClosingOptions().map((label, optionIdx)  => (
                                    <Form.Check
                                      key={`${fieldKey}-${optionIdx}`}
                                      type="checkbox"
                                      label={label}
                                      checked={formValues[`${fieldKey}-${optionIdx}`] === "true"}
                                      onChange={() => {
                                        // Uncheck all other checkboxes
                                        const newFormValues = { ...formValues };
                                        for (let i = 0; i < 2; i++) {
                                          newFormValues[`${fieldKey}-${i}`] = "false";
                                        }
                                        // Check the selected checkbox
                                        newFormValues[`${fieldKey}-${optionIdx}`] = "true";
                                        setFormValues(newFormValues);
                                        dispatch(setIndicators("IsPageDirty", true));
                                      }}
                                    />
                                  ))}
                                </>
                              ) 
                              : (
                                <Form.Check
                                  type="checkbox"
                                  label={fieldDisplayNames[field.name]}
                                  checked={formValues[fieldKey] === "true"}
                                  onChange={(e) => {
                                    const newValue = e.target.checked;
                                    setFormValues((prevValues) => {
                                      const updatedValues = {
                                        ...prevValues,
                                        [fieldKey]: newValue ? "true" : "false",
                                      };
                                      dispatch(setIndicators("IsPageDirty", true));
                                      // Always reset additional fields when checkbox status changes
                                      const additionalFieldsConfig = {
                                        "Citizenship.PurchaserIsNotNonResident": ["Country of Residence"],
                                        "PurchaserInformationESigning.AddressForServicePostClosing": ["Enter Address for Service"]
                                        // Add more mappings as needed
                                      };
                                      const additionalFields = additionalFieldsConfig[field.name];
                                      if (additionalFields) {
                                        additionalFields.forEach((_, fieldIdx) => {
                                          updatedValues[`${fieldKey}-additional-${fieldIdx}`] = "";
                                        });
                                      }

                                      return updatedValues;
                                    });
                                  }}
                                  style={{
                                    color: formValues[fieldKey] === "true" ? "blue" : "inherit",
                                  }}
                                />
                              )}
                            </Form.Group>
                          </Col>
                          {renderPurchaserAdditionalFields(field.name, purchaser.name, idx)}
                        </Row>
                      );
                    })}

                    </Form>
                  </Col>
                );
              })}
            </Row>
            </Card.Body>
        ) : (
            <Loading />
        )}
      </Card>

      <Card>
        <Card.Header>
            <h2>Requested Documents</h2>
        </Card.Header>

        <Card.Body>
            <Alert variant="info">
                <b>Upload the documents below.</b> Download and complete the documents if they are provided on the <b>Documents page</b>.
            </Alert>
            <Row className="gx-2">
                {thirdPartyDocInfo.map((file, index) => (
                file.DocumentName.replace(".pdf", "") !== "" && <Col sm={4} className="mt-2">
                    <ThirdPartyUpload
                        isUploaded={thirdPartyDocUploadStatus[index]}
                        key={index}
                        documentName={file.DocumentName.replace(".pdf", "")}
                        posting={file.PostingCaption}
                        sid={sessionInfo.sid}
                        msgID={builderState.msgID}
                        requestRemove={file.RequestRemove}
                    />
                </Col>
                ))}
            </Row>
        </Card.Body>
      </Card>

    <Card>
        <Card.Header>
            <Card.Title>Option A: Remote eSigning</Card.Title>
        </Card.Header>

        <Card.Body>
            {schedule.length === 0 ? 
                <Alert variant="info" className="mb-3">Schedule a virtual eSigning Session with your client(s).</Alert>
                :
                <Alert variant="success" className="mb-3">Your virtual eSigning session is scheduled for 
                    <>
                        <i className="fa-regular fa-calendar"></i>
                        <b>
                            {(() => {
                                const date = new Date(schedule[0].ScheduledStartTime);
                                const year = date.getUTCFullYear();
                                const month = date.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
                                const day = date.getUTCDate();
                                const hours = date.getUTCHours();
                                const minutes = date.getUTCMinutes().toString().padStart(2, '0');
                                const ampm = hours >= 12 ? 'PM' : 'AM';
                                const formattedHour = hours % 12 || 12;

                                return `${month} ${day}, ${year} ${formattedHour}:${minutes} ${ampm}`;
                            })()}
                        </b>
                    </>
                </Alert>
            }
            <div className="mb-3">
                <a href="https://ldd.ca/esigning-instructions" target="_blank" rel="noopener noreferrer">
                    <i className="fa-solid fa-external-link"></i> About LDD's Remote eSigning Platform
                </a>
            </div>

            {schedule.length === 0 && (
                <>
                    <Button variant="primary" onClick={() => setShowRemoteSigningModal(true)}>
                        <i className="fa-regular fa-pencil"></i>
                        Schedule Session
                    </Button>
                </>
            )}

            {schedule.length > 0 && (
                <>
                    <Button variant="primary" onClick={handleRemoteSigningClick}>
                        <i className="fa-regular fa-video"></i>
                        Launch Virtual eSigning Session
                    </Button>

                    <Button variant="link" onClick={() => setShowRemoteSigningModal(true)}>
                        <i className="fa-regular fa-pencil"></i>
                        Edit Session
                    </Button>
                </>
            )}
        </Card.Body>
    </Card>

        <Card className="card-list">
        
        <Card.Header>
            <Card.Title>Option B: eSigning with Client(s) In-Person</Card.Title>
        </Card.Header>

        <Card.Body>
            {(!sellerDocs || sellerDocs.length === 0) ? (
                <ListPlaceholder 
                    icon="fa-light fa-calendar-star" 
                    title="No documents to display."
                    msg=""
                />
            ):(
                <Table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Note</th>
                            <th>Posting</th>
                            <th>Review</th>
                            <th>Sign</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sellerTableBody()}
                    </tbody>
                </Table>
            )}
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Attention</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Please import the property details from 'Import Information' to identify the address for service as the purchase property.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <ScheduleEsign
          purchasers={purchasers}
          setScheduledTime={setScheduledTime}
          getRemoteSigningSchedule={getRemoteSigningSchedule}
          showModal={showRemoteSigningModal}
          onHideModal={() => {
              setShowRemoteSigningModal(false)
              setScheduleandPortalData()
          }}
          sellerDocs={sellerDocs}
          sessionInfo={sessionInfo}
          setShowModal={setShowRemoteSigningModal}
          clientEmail={clientEmail}
          firmName={firmName}
          projectName={projectName}
          msgID={builderState.msgID}
          reschedule={schedule.length > 0} 
          packageList={JuratPackageList}
          address={propertyAddress}
          vendorFirmName={vendorFirmName}
          clientName={clientName}
          contractPrice={contractPrice}
          deposits={deposits}
          mortgageinfo={mortgageinfo}
          esignAskfieldsFormData={formData}
          initLawyerName={initLawyerName}
          checkIfAllFieldsAreFilled={checkIfAllFieldsAreFilled}
      />

        <JuratDetailModal
            purchasers={purchasers}
            show={showJuratModal}
            isRemoteSigning={isRemoteSigning}
            onHide={() => setShowJuratModal(false)}
            lawyerName={lawyerName}
            JuratPackageList={JuratPackageList}
            msgId={builderState.msgID}
            sessionId={sessionInfo.sid}
            appId={builderState.appId}
            province={'ON'}
            meetingid={schedule[0]?.MeetingID || null}
            fileName={juratFileName}
            shortcode={schedule[0]?.Shortcode}
            onStartEsigning={(msgID, fileName, remoteSigning) =>
              handleSubmitForms(msgID, fileName, remoteSigning)
            } 
        />
        {loading && <Loading showMsg={true} extraMsg="Launch Remote eSigning Session..." />}
    </>
  );
};

// Function to filter fields
function filterFields(
  fields: {
    name: string;
    value: string;
    editable: boolean;
    purchasername?: string;
  }[]
) {
  const checkboxFieldNames = [
    "PowerOfAttorney.PowerOfAttorneyApplicable",
    "Occupancy.PurchaserOccupancy",
    "Occupancy.OccupantIsRelative",
    "Occupancy.OccupantIsTenant",
    "Occupancy.OccupantIsDwelling",
    "PurchaserDetailsESigning.HSTEligibility",
    "PurchaserDetailsESigning.HSTEligibilitySimple",
    "PurchaserDetailsESigning.OccupantDetails",
    "AssigneeDetailsESigning.AssigneeHSTEligibility"
  ];

  const normalFieldNames = [
    "PaymentDetails.AccountNumber",
    "PaymentDetails.TransitNumber",
    "PaymentDetails.InstitutionNumber",
    "ClosingDetailsESigning.DocumentDatedAt",
    "ClosingDetailsESigning.DocumentDatedAtMonth",
    "ClosingDetailsESigning.DocumentDatedAtYear",
    "ClosingDetailsESigning.KeyPickupDesignate",
    "AssigneeDetailsESigning.AssigneeSolicitorName",
    "AssigneeDetailsESigning.AssigneeSolicitorEmail",
    "PurchaserDetailsESigning.UndersignedRelationship",
    "PurchaserInformationESigning.RebateClaimantDaytimePhoneNumber"
  ];

  const purchaserSpecificFields = [
    "Citizenship.PurchaserIsNonResident",
    "Citizenship.PurchaserIsNotNonResident",
    "Citizenship.TemporaryResident",
    "Citizenship.ProtectedCitizen",
    "PurchaserDetailsESigning.PurchaserSpousalDeclaration",
    "PurchaserDetailsESigning.PrincipalResidenceDeclaration",
    "PurchaserInformationESigning.AddressForServicePostClosing"
  ];

  const purchaserSpecificStringFields = [
    "PurchaserInformationESigning.PurchaserSocialInsuranceNumber",
    "PurchaserInformationESigning.PurchaserBusinessIdentificationNumber",
    "PurchaserDetailsESigning.PurchaserPercentageInterestOfOwnership",
    "PurchaserInformationESigning.PurchaserBirthdate",
    "PurchaserInformationESigning.PurchaserMaritalStatus",
    "PurchaserInformationESigning.PurchaserJointTenants",
    "PurchaserInformationESigning.PurchaserTelephoneNumber",
    "PurchaserInformationESigning.PurchaserEmailAddress",
    "PurchaserInformationESigning.PurchaserIDTypeSubmitted",
    "PurchaserInformationESigning.PurchaserIDNumberSubmitted",
    "PurchaserInformationESigning.PurchaserOccupation",
    "PurchaserInformationESigning.PurchaserExpiryDates",
    "PurchaserDetailsESigning.MessageTransferTo",
    "PurchaserInformationESigning.PurchaserName"
  ];

  type FieldType = {
    name: string;
    value: string;
    editable: boolean;
    purchasername?: string;
  };

  const uniqueFields = (fields: FieldType[]) => {
    const seen = new Set();
    return fields.filter((field) => {
      if (seen.has(field.name)) {
        return false;
      }
      seen.add(field.name);
      return true;
    });
  };

  const checkboxFields = uniqueFields(
    fields.filter((field) => checkboxFieldNames.includes(field.name))
  );

  const normalFields = uniqueFields(
    fields.filter((field) => normalFieldNames.includes(field.name))
  );

  const specificFields = (() => {
    const seen = new Set();
    return fields.filter((field) => {
      if (!purchaserSpecificFields.includes(field.name)) {
        return false;
      }
      if (!field.purchasername || field.purchasername.trim() === '') {
        return false;
      }
      const key = `${field.name}-${field.purchasername}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  })();

  const stringSpecificFields = (() => {
    const seen = new Set();
    return fields.filter((field) => {
      if (!purchaserSpecificStringFields.includes(field.name)) {
        return false;
      }
      if (!field.purchasername || field.purchasername.trim() === '') {
        return false;
      }
      const key = `${field.name}-${field.purchasername}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  })();

  return {
    checkboxFields,
    normalFields,
    specificFields,
    stringSpecificFields,
  };
}

// Helper function to format date as YYYY/MM/DD
const formatDateYYYYMMDD = (date: Date | null): string => {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}/${month}/${day}`;
};

// Helper function to parse YYYY/MM/DD string to Date
const parseDateYYYYMMDD = (dateString: string | undefined): Date | null => {
  if (!dateString) return null;
  // Handle both YYYY/MM/DD and YYYY-MM-DD formats
  const normalizedDate = dateString.replace(/-/g, '/');
  const parts = normalizedDate.split('/');
  if (parts.length === 3) {
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
    const day = parseInt(parts[2], 10);
    const date = new Date(year, month, day);
    // Validate the date
    if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
      return date;
    }
  }
  return null;
};

// Mapping of field names to display names
const fieldDisplayNames: { [key: string]: string } = {
  "PaymentDetails.AccountNumber": "Account Number",
  "PaymentDetails.TransitNumber": "Transit Number",
  "PaymentDetails.InstitutionNumber": "Institution Number",
  "ClosingDetailsESigning.DocumentDatedAt": "Document Dated At Day",
  "ClosingDetailsESigning.DocumentDatedAtMonth": "Document Dated At Month",
  "ClosingDetailsESigning.DocumentDatedAtYear": "Document Dated At Year",
  "ClosingDetailsESigning.KeyPickupDesignate": "Key Pickup Designate",
  "PurchaserDetailsESigning.HSTEligibility": "HST Rebate Eligibility",
  "PurchaserDetailsESigning.HSTEligibilitySimple": "HST Eligibility",
  "PurchaserDetailsESigning.OccupantDetails": "The unit will be occupied by:",
  "PowerOfAttorney.PowerOfAttorneyApplicable": "Power of Attorney Applicable",
  "Citizenship.PurchaserIsNonResident":
    "Purchaser is a non-resident of Canada, or will be a non-resident at the time of final closing",
  "Citizenship.PurchaserIsNotNonResident":
    "The purchaser is not a non-resident of Canada and will not be a non-resident at the time of final closing",
  "Citizenship.TemporaryResident":
    "I was a temporary resident and will be on final closing",
  "Citizenship.ProtectedCitizen":
    "I was a protected citizen and will continue to be on the final closing",
  "Occupancy.PurchaserOccupancy": "Purchaser(s) will Occupy Unit",
  "Occupancy.OccupantIsRelative":
    "Occupant is someone with a relationship to the purchaser",
  "Occupancy.OccupantIsTenant": "Occupant will be a tenant",
  "Occupancy.OccupantIsDwelling": "This dwelling will be my primary residence",
  "PurchaserInformationESigning.PurchaserSocialInsuranceNumber":
    "Purchaser Social Insurance Number",
  "PurchaserInformationESigning.PurchaserName":
    "Purchaser Name (LAST NAME, First Name)",
  "PurchaserInformationESigning.PurchaserBusinessIdentificationNumber":
    "Business Identification Number",
  "PurchaserDetailsESigning.PurchaserPercentageInterestOfOwnership":
    "Percentage Interest of Ownership",
  "PurchaserDetailsESigning.MessageTransferTo":
    "Message Transfer To",
  "PurchaserInformationESigning.PurchaserBirthdate":
    "Purchaser Birthdate",
  "PurchaserInformationESigning.PurchaserMaritalStatus":
    "Spousal Status",
  "PurchaserInformationESigning.PurchaserJointTenants":
    "Joint Tenants or Tenants in Common",
  "PurchaserDetailsESigning.PurchaserSpousalDeclaration":
    "Spousal Declaration",
  "PurchaserInformationESigning.AddressForServicePostClosing":
    "Address for Service Post Closing",
  "PurchaserDetailsESigning.PrincipalResidenceDeclaration":
    "Principal Residence Declaration",
  "PurchaserInformationESigning.PurchaserTelephoneNumber":
    "Telephone number",
  "PurchaserInformationESigning.PurchaserEmailAddress":
    "Email Address",
  "PurchaserInformationESigning.PurchaserIDTypeSubmitted":
    "ID Type Submitted",
  "PurchaserInformationESigning.PurchaserIDNumberSubmitted":
    "ID Document Number",
  "PurchaserInformationESigning.PurchaserOccupation":
    "Occupation",
  "PurchaserInformationESigning.PurchaserExpiryDates":
    "ID Document Expiry Date",
  "AssigneeDetailsESigning.AssigneeSolicitorName":
    "Assignee Solicitor Name",
  "AssigneeDetailsESigning.AssigneeSolicitorEmail": "Assignee Solicitor Email",
  "AssigneeDetailsESigning.AssigneeHSTEligibility": "Assignee is Eligible for the HST Rebate",
  "PurchaserDetailsESigning.UndersignedRelationship": "Purchasers Relationship",
  "PurchaserInformationESigning.RebateClaimantDaytimePhoneNumber": "Rebate Claimant Daytime Phone Number"
};

const NormalFieldsPlaceholders: Record<string, string> = {
  "ClosingDetailsESigning.DocumentDatedAt": "e.g., '1st'",
  "ClosingDetailsESigning.DocumentDatedAtMonth": "e.g., 'March'",
  "ClosingDetailsESigning.DocumentDatedAtYear": "e.g., '2025'",
  "ClosingDetailsESigning.KeyPickupDesignate": "Enter name of key pickup individual",
  "Purchaser Occupant(s) and other Occupant(s)": "Enter name(s) of purchaser occupant(s)",
  "Relationship to Non-Occupying Purchasers": "Write n/a if not applicable",
  "Name(s) of Occupant(s)": "Enter name(s) of relation occupants",
  "Relationship of Occupant to each Purchaser": "Enter the occupant’s relationship to the purchaser(s)",
  "Name of Tenant(s)": "Enter the name of the tenant(s)",
  "AssigneeDetailsESigning.AssigneeSolicitorName": "e.g., John Smith",
  "AssigneeDetailsESigning.AssigneeSolicitorEmail": "e.g., john@ldd.ca",
  "PurchaserDetailsESigning.UndersignedRelationship": "If only one purchaser, enter n/a",
  "PurchaserInformationESigning.RebateClaimantDaytimePhoneNumber": "E.g., 416 367 0600",
 

};

const PurchaserFieldsPlaceholders: Record<string, string> = {
  "PurchaserDetailsESigning.PurchaserPercentageInterestOfOwnership": "e.g., 50%",
  "PurchaserInformationESigning.PurchaserMaritalStatus": "e.g., we are spouses",
  "PurchaserInformationESigning.PurchaserJointTenants": "e.g., Joint Tenants",
  "PurchaserInformationESigning.PurchaserTelephoneNumber": "e.g., 416 - 555-0600",
  "PurchaserInformationESigning.PurchaserEmailAddress": "e.g., info@ldd.ca",
  "PurchaserInformationESigning.PurchaserIDTypeSubmitted": "e.g., Passport",
  "PurchaserInformationESigning.PurchaserIDNumberSubmitted": "e.g., 123 456 789",
  "PurchaserInformationESigning.PurchaserOccupation": "e.g., Engineer",
  "PurchaserInformationESigning.PurchaserExpiryDates": "e.g., November 1st, 2027",
   "PurchaserInformationESigning.PurchaserName": "Enter the Purchaser Name"
};

const additionalFieldsConfig = {
  "PowerOfAttorney.PowerOfAttorneyApplicable": ["Power of Attorney Name"],
  "PurchaserInformationESigning.AddressForServicePostClosing": ["Enter Address for Service"],
  "Citizenship.PurchaserIsNotNonResident": ["Country of Residence"],
  "Occupancy.OccupantIsRelative": [
    "Occupant Name",
    "Occupant Relationship to Purchaser",
  ],
  "Occupancy.OccupantIsTenant": ["Occupant Name"],
  // Add more mappings as needed
};

const additionalFieldsForOccupantDetailsConfig = {
  "PurchaserDetailsESigning.OccupantDetails-0": [
    "Purchaser Occupant(s) and other Occupant(s)",
    "Relationship to Non-Occupying Purchasers",
  ],
  "PurchaserDetailsESigning.OccupantDetails-1": [
    "Name(s) of Occupant(s)",
    "Relationship of Occupant to each Purchaser",
  ],
  "PurchaserDetailsESigning.OccupantDetails-2": ["Name of Tenant(s)"],
};

